module.exports = __webpack_public_path__ + "img/coverPlaceDark.4801fb5f.png";